import { ROUTES } from '../routes/constants';

export const sidebarData = [
  // ── Shared ──────────────────────────────────────────────────────────────────
  {
    label: 'dashboard',
    icon: '/assets/dashboardIcon.svg',
    activeIcon: '/assets/dashboardIconActive.svg',
    route: ROUTES.HOME,
    type: ['user', 'brandUser', 'admin'],
    access: 'free',
  },

  // ── User / Brand user ────────────────────────────────────────────────────────
  {
    label: 'campaign',
    baseRoute: '/campaign',
    icon: '/assets/campaign.svg',
    activeIcon: '/assets/campaignActive.svg',
    route: ROUTES.CREATE_CAMPAIGN,
    type: ['brandUser'],
    access: 'free',
    subMenu: [
      {
        label: 'createnew',
        icon: '/assets/plus-square.svg',
        activeIcon: '/assets/plus-square-active.svg',
        route: ROUTES.CREATE_CAMPAIGN,
        access: 'limited',
      },
      {
        label: 'scheduled',
        icon: '/assets/fi_calendar.svg',
        activeIcon: '/assets/fi_calendarActive.svg',
        route: ROUTES.SCHEDULED_CAMPAIGN,
        access: 'limited',
      },
      {
        label: 'active',
        icon: '/assets/trending-up.svg',
        activeIcon: '/assets/trending-upActive.svg',
        route: ROUTES.ACTIVE_CAMPAIGN,
        access: 'limited',
      },
      {
        label: 'completed',
        icon: '/assets/check-circle.svg',
        activeIcon: '/assets/check-circleActive.svg',
        route: ROUTES.COMPLETED_CAMPAIGN,
        access: 'limited',
      },
      {
        label: 'analytics',
        icon: '/assets/bar-chart-square-02.svg',
        activeIcon: '/assets/bar-chart-square-02-active.svg',
        route: ROUTES.ANALYTICS_CAMPAIGN,
        access: 'limited',
      },
    ],
  },
  {
    label: 'smartlinks',
    icon: '/assets/smartLink.svg',
    activeIcon: '/assets/smartLinkActive.svg',
    route: ROUTES.MY_LINKS,
    type: ['user'],
    access: 'free',
    subMenu: [
      {
        label: 'mylinks',
        icon: '/assets/linkIcon.svg',
        activeIcon: '/assets/linkIconActive.svg',
        route: ROUTES.MY_LINKS,
        type: ['user'],
        access: 'free',
      },
      {
        label: 'bulkupload',
        icon: '/assets/uploadIcon.svg',
        activeIcon: '/assets/uploadIconActive.svg',
        route: ROUTES.BULK_UPLOAD,
        type: ['user'],
        access: 'limited',
      },
      {
        label: 'analytics',
        icon: '/assets/analyticsIcon.svg',
        activeIcon: '/assets/analyticsIconActive.svg',
        route: ROUTES.ANALYTICS,
        type: ['user'],
        access: 'limited',
      },
    ],
  },
  {
    label: 'usermanagement',
    icon: '/assets/users.svg',
    activeIcon: '/assets/usersActive.svg',
    route: ROUTES.USER_MANAGEMENT,
    type: ['brandUser'],
    access: 'free',
  },

  // ── Admin ────────────────────────────────────────────────────────────────────
  {
    label: 'campaigns',
    baseRoute: '/admin/campaigns',
    icon: '/assets/campaign.svg',
    activeIcon: '/assets/campaignActive.svg',
    route: ROUTES.ADMIN_CAMPAIGNS,
    type: ['admin'],
    access: 'free',
    subMenu: [
      {
        label: 'allcampaigns',
        icon: '/assets/campaign.svg',
        activeIcon: '/assets/campaignActive.svg',
        route: ROUTES.ADMIN_CAMPAIGNS,
        type: ['admin'],
        access: 'free',
      },
    ],
  },
  {
    label: 'brands',
    baseRoute: '/admin/brands',
    icon: '/assets/briefcase.svg',
    activeIcon: '/assets/briefcaseActive.svg',
    route: ROUTES.ADMIN_BRANDS,
    type: ['admin'],
    access: 'free',
    subMenu: [
      {
        label: 'activebrands',
        icon: '/assets/briefcase.svg',
        activeIcon: '/assets/briefcaseActive.svg',
        route: ROUTES.ADMIN_BRANDS,
        type: ['admin'],
        access: 'free',
      },
      {
        label: 'brandwaitlist',
        icon: '/assets/waitlistQueue.svg',
        activeIcon: '/assets/waitlistQueueActive.svg',
        route: ROUTES.BRAND_SUBSCRIBERS,
        type: ['admin'],
        access: 'free',
      },
    ],
  },
  {
    label: 'creators',
    baseRoute: '/admin/creators',
    icon: '/assets/users.svg',
    activeIcon: '/assets/usersActive.svg',
    route: ROUTES.ADMIN_CREATORS,
    type: ['admin'],
    access: 'free',
    subMenu: [
      {
        label: 'allcreators',
        icon: '/assets/users.svg',
        activeIcon: '/assets/usersActive.svg',
        route: ROUTES.ADMIN_CREATORS,
        type: ['admin'],
        access: 'free',
      },
      {
        label: 'creatorsWaitlist',
        icon: '/assets/clock.svg',
        activeIcon: '/assets/clockActive.svg',
        route: ROUTES.CREATORS_WAITLIST,
        type: ['admin'],
        access: 'free',
      },
      {
        // walletIcon.svg already ships in public/assets; the active variant
        // is the same artwork with this sidebar's active stroke colour
        // (#020D3A), matching every other icon pair here.
        label: 'creatorPayouts',
        icon: '/assets/walletIcon.svg',
        activeIcon: '/assets/walletIconActive.svg',
        route: ROUTES.CREATOR_PAYOUTS,
        type: ['admin'],
        access: 'free',
      },
    ],
  },
  {
    label: 'submissions',
    baseRoute: '/admin/submissions',
    icon: '/assets/submissionsContent.svg',
    activeIcon: '/assets/submissionsContentActive.svg',
    route: ROUTES.ADMIN_SUBMISSIONS,
    type: ['admin'],
    access: 'free',
    subMenu: [
      {
        label: 'allsubmissions',
        icon: '/assets/submissionsContent.svg',
        activeIcon: '/assets/submissionsContentActive.svg',
        route: ROUTES.ADMIN_SUBMISSIONS,
        type: ['admin'],
        access: 'free',
      },
      {
        label: 'flaggedsubmissions',
        icon: '/assets/flag.svg',
        activeIcon: '/assets/flagActive.svg',
        route: ROUTES.FLAGGED_SUBMISSIONS,
        type: ['admin'],
        access: 'free',
      },
      {
        label: 'cashbackLedger',
        icon: '/assets/walletIcon.svg',
        activeIcon: '/assets/walletIcon.svg',
        route: ROUTES.CASHBACK_LEDGER,
        type: ['admin'],
        access: 'free',
      },
      {
        label: 'bonusLedger',
        icon: '/assets/walletIcon.svg',
        activeIcon: '/assets/walletIcon.svg',
        route: ROUTES.BONUS_LEDGER,
        type: ['admin'],
        access: 'free',
      },
    ],
  },
  {
    label: 'analytics',
    icon: '/assets/analyticsIcon.svg',
    activeIcon: '/assets/analyticsIconActive.svg',
    route: ROUTES.ADMIN_ANALYTICS,
    type: ['admin'],
    access: 'free',
  },
  {
    label: 'newslettersubscribers',
    icon: '/assets/newsletterMail.svg',
    activeIcon: '/assets/newsletterMailActive.svg',
    route: ROUTES.NEWSLETTER_SUBSCRIBERS,
    type: ['admin'],
    access: 'free',
  },

  // ── Legacy ───────────────────────────────────────────────────────────────────
  {
    label: 'campaign',
    icon: '/assets/compaignIcon.svg',
    activeIcon: '/assets/compaignIconActive.svg',
    type: ['influencer', 'brand'],
    route: undefined,
    access: 'limited',
  },
];

export const COUNTRIES = [
  { name: 'EN', code: 'en' },
  { name: 'FR', code: 'fr' },
];
